import React from 'react';

import {schemaInterfacesURL} from 'schemas/schema-interface/SchemaInterfaceDAO';
import {schemaFieldsetNamePluralized} from 'schemas/schema-interface/util/schemaFieldsetName';
import getTestProps from 'test/lib/cypress/getTestProps';
import {capitalize, capwords} from 'util/NameUtil';

import EmptySidebarIcon from './EmptySidebarIcon';
import {Section, SettingsSection} from './SidebarConstants';
import SidebarItem from './SidebarItem';

export interface SchemaInterfaceSettingsProps {
  section: SettingsSection;
}

export default function SchemaInterfaceSettings({section}: SchemaInterfaceSettingsProps): JSX.Element {
  return (
    <div {...getTestProps({component: 'SchemaInterfaceSettings', element: 'sidebar'})}>
      <div
        {...getTestProps({component: 'SchemaInterfaceSettings', element: 'header'})}
        className="browser-nav-header"
      >
        {capwords(schemaFieldsetNamePluralized())}
      </div>
      <SidebarItem
        active={section === Section.SCHEMA_INTERFACE_SETTINGS}
        icon={<EmptySidebarIcon />}
        name={capitalize(schemaFieldsetNamePluralized())}
        link={schemaInterfacesURL()}
        dataTestAttrsKey="schemaInterfaces"
      />
    </div>
  );
}
